import WAboutCompareFirstTablet from './WAboutCompareFirstTablet'

export default WAboutCompareFirstTablet
